const initialState = {
  error: null,
  isLoading: false,
  offlineMode: false,
  branchPk: localStorage.getItem('branchPk') && localStorage.getItem('branchPk') !== 'null' ? localStorage.getItem('branchPk') : null
};


const commonReducer = (state = initialState, action) => {
  switch (action.type) {
  case 'REQUEST_SUCCESSFUL':
    return Object.assign({}, state, {
      error: null,
      isLoading: false,
    });
  case 'REQUEST_FAILURE':
    return Object.assign({}, state, {
      error: action.payload.error,
      isLoading: false,
    });
  case 'МАКЕ_REQUEST':
    return Object.assign({}, state, {
      error: null,
      isLoading: true,
    });
  case 'RESET_ERROR':
    return Object.assign({}, state, {
      error: null,
    });
  case 'SET_BRANCH_PK':
    return Object.assign({}, state, {
      branchPk: action.payload.branchPk,
    });
  case 'SET_OFFLINE_MODE':
    return Object.assign({}, state, {
      offlineMode: action.payload.offlineMode,
    });
  default:
    return state;
  }
};


export default commonReducer;
